import { createContext } from 'react';
import { IUpdateRestaurantReports, TTypeOfSchedule, TTypeOfReport } from 'types';
import { IReportsWithCustomProps, CREATE_REPORT } from '../../../../reportsContainerState/reportsContainerContext';

export interface IDataForSubmit extends IUpdateRestaurantReports {
	restaurantId: string;
	reportType: TTypeOfReport;
}
export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface IEmails {
	id: string;
	email: string;
}

export interface IReportsState {
	hasBanOnChanges: boolean;
	restaurantId: string;
	id: string;
	IDReportType: null | TTypeOfReport;
	IDsScheduleTypes: TTypeOfSchedule[];
	emails: IEmails[];
	copyEmails: IEmails[];
	sendingReportAfterShiftClosing: boolean;
	dataForSubmit: IDataForSubmit | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const reportsInitialState: IReportsState = {
	hasBanOnChanges: false,
	restaurantId: '',
	id: CREATE_REPORT,
	IDReportType: null,
	IDsScheduleTypes: [],
	emails: [],
	copyEmails: [],
	sendingReportAfterShiftClosing: false,
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IReportsContext extends IReportsState {
	setHasBanOnChanges(): void;
	setAllData(value: IReportsWithCustomProps): void;
	setIDReportType(value: null | TTypeOfReport): void;
	setIDsScheduleTypes(value: TTypeOfSchedule[]): void;
	addEmails(value: IEmails): void;
	changeEmails(emailId: string, email: string): void;
	deleteEmails(emailId: string): void;
	addCopyEmails(value: IEmails): void;
	changeCopyEmails(copyEmailId: string, email: string): void;
	deleteCopyEmails(copyEmailId: string): void;
	toggleSendingReportAfterShiftClosing(): void;
	setDataForSubmit(value: IDataForSubmit | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ReportsContext = createContext<IReportsContext>({
	setHasBanOnChanges: () => undefined,
	setAllData: () => undefined,
	setIDReportType: () => undefined,
	setIDsScheduleTypes: () => undefined,
	addEmails: () => undefined,
	changeEmails: () => undefined,
	deleteEmails: () => undefined,
	addCopyEmails: () => undefined,
	changeCopyEmails: () => undefined,
	deleteCopyEmails: () => undefined,
	toggleSendingReportAfterShiftClosing: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...reportsInitialState,
});
